export const indexName = 'prod_searchable_posts';

export const suggestionsIndexName = 'prod_searchable_posts_query_suggestions';
export const searchParam = 'query';
export const siteTitle = 'Eagle Mountain City';

// base is used in parent CLASS in index.js
const base = {
	selectors: {
		searchWrap: '.algolia__search-wrap',
	},
	classes: {
		facet: 'algolia__facet',
	},
};

const facets = {
	location: 'algolia__facets-wrap',
	cssClasses: {
		opened: 'algolia__facet--opened',
		toggle: 'algolia__facet-toggle',
		list: 'algolia__facet-filters',
		item: 'algolia__facet-filter',
		link: 'algolia__facet-filter-link',
		facet: 'algolia__facet',
		disabled: 'algolia__facet--disabled',
	},
};

const configure = {
	hitsPerPage: 9,
	maxValuesPerFacet: 20,
	snippetEllipsisText: '…',
	distinct: true,
	clickAnalytics: true,
	enablePersonalization: true,
	attributesToSnippet: [ 'post_title:7', 'post_content:15', 'post_excerpt:15' ],
};

export const searchBox = {
	autofocus: true,
	showReset: false,
	showSubmit: true,
	placeholder: 'Enter Keywords...',
	container: '.algolia__facet--searchBox',
	location: 'algolia__input-wrap',
	cssClasses: {
		input: 'algolia__search-input',
		main: 'algolia__input--main',
		shadow: 'algolia__input--shadow',
		submit: 'algolia__search-submit',
		form: 'algolia__search',
	},
};

const autocomplete = {
	respondAtThisMany: 3,
	...searchBox,
	cssClasses: {
		main: 'algolia__input--main',
		shadow: 'algolia__input--shadow',
		list: 'algolia__autocomplete-results',
		item: 'algolia__autocomplete-result',
		link: 'algolia__result-link',
		label: 'algolia__result-title',
		...searchBox.cssClasses,
	},
};

const voiceSearch = {
	container: '.algolia__facet--voiceSearch',
	location: 'algolia__input-wrap',
	language: 'en-US',
	searchAsYouSpeak: true,
	cssClasses: {
		button: 'algolia__voice-search-button',
		status: 'algolia__voice-search-stats',
	},
};

const hits = {
	escapeHTML: false,
	container: '.algolia__hits-wrap',
	location: 'algolia__output-wrap',
	imageSize: 'medium',
	cssClasses: {
		emptyRoot: 'algolia__hits--empty',
		list: 'algolia__hits',
		item: 'algolia_hit',
		input: 'algolia__input',
		formWrap: 'algolia__form-wrap',
		form: 'algolia__form',
		root: '',
	},
};

const pagination = {
	container: '.algolia__pagination',
	location: 'algolia__output-wrap',
	padding: 2,
	showFirst: true,
	showLast: true,
	cssClasses: {
		root: 'pagination',
		list: 'pagination__items',
		item: 'pagination__item',
		link: 'pagination__link',
		firstPageItem: 'pagination__item--first',
		lastPageItem: 'pagination__item--last',
		selectedItem: [ 'pagination__link', 'current' ],
		nextItem: 'pagination__item--next',
		numbers: 'pagination__item--numbers',
		number: 'pagination__number',
		previousItem: 'pagination__item--previous',
		disabledItem: 'pagination__link--disabled',
	},
};

const clearRefinements = {
	container: '.algolia__clearRefinements',
	location: 'algolia__output-wrap',
	text: {
		label: 'Clear All',
	},
	cssClasses: {
		root: 'algolia__active',
		button: 'algolia__active-filter',
		item: 'algolia__active-filter',
		text: 'algolia__active-filter-text',
		list: 'algolia__active-filters',
	},
};

const currentRefinements = {
	container: '.algolia__currentRefinements',
	location: 'algolia__output-wrap',
	text: {
		label: 'Applied Filters',
	},
	showCount: true,
	cssClasses: {
		root: '',
		disabled: 'algolia__refinements-button--disabled',
		list: 'algolia__active-filters',
		activeLabel: 'algolia__active-label has-meta-variant',
		delete: 'algolia__active-filter-delete',
		item: 'algolia__active-filter',
		categoryLabel: 'algolia__active-filter-text',
		label: 'algolia__active-filter-label',
		facetLabel: 'algolia__facet-label',
	},
};

export const opts = {
	base,
	siteTitle,
	indexName,
	searchParam,
	configure,
	currentRefinements,
	clearRefinements,
	hits,
	pagination,
	voiceSearch,
	autocomplete,
	facets,
	searchBox,
};
